module.exports = __webpack_public_path__ + "static/img/jingNiubg.5cc56858.png";